import { createHttpEndpoint } from '../../utils'

import type { PopularityStatsSales } from './popularity-stats.types'

/**
 * Endpoint to get the last 7 days sales for a given product
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/popularity-stats-api/definition#/default/get_products}
 */
export const getPopularityStatsSales = createHttpEndpoint<
  PopularityStatsSales[]
>({
  method: 'GET',
  operationId: 'getPopularityStatsSales',
  path: '/api/popularity-stats/v2/products/',
})
